<template>

    <!-- <div class="row pricing-table-one">
        <div class="col-md-6 col-xl-3 pricing-table wow move-up" v-for="(pricing, index) in pricingTable" :key="index">
            <div class="pricing-table__inner">
                <div class="pricing-table__feature-mark" v-if="pricing.isPopular">
                    <span>Popular Choice</span>
                </div>
                <div class="pricing-table__header">
                    <div class="pricing-table__image">
                        <img :src="pricing.thumb" class="img-fluid" :alt="pricing.alt">
                    </div>
                    <h5 class="pricing-table__title">{{ pricing.title }}</h5>
                    <div class="pricing-table__price-wrap">
                        <h6 class="currency">¥</h6>
                        <h6 class="price">{{ pricing.value }}</h6>
                        <h6 class="period">/{{ pricing.duration }}</h6>
                    </div>
                </div>
                <hr>
                <div class="pricing-table__body">
                    <ul class="pricing-table__list">
                        <li v-for="(list, index) in pricing.price" :key="index">{{ list }}</li>
                    </ul>
                </div>
                <div class="pricing-table__footer">
                    <a href="#" class="ht-btn ht-btn-default" :class="{'ht-btn--outline': pricing.active}">Get started</a>
                </div>
            </div>
        </div>
    </div> -->
    <div class="feature-icon-list">
        <div class="row">
            <div class="col-lg-12">
                <!-- <h5 class="margin-bottom-20">価格の設定は以下の通りです。</h5> -->
                <hr>
                <ul class="ul-style margin-bottom-20">
                    <li class="margin-bottom-20"><h5>{{lan.key41[cur_lan]}}</h5></li>
                    <li class="margin-bottom-20"><h5>{{lan.key42[cur_lan]}}</h5></li>
                    <li class="margin-bottom-20"><h5>{{lan.key43[cur_lan]}}</h5></li>
                    <li class="margin-bottom-20"><h5>{{lan.key44[cur_lan]}}</h5></li>
                </ul>
            </div>
            <!-- <div class="col-lg-4">
                <div class="feature-icon-list__media wow move-up">
                    <img src="../assets/img_design/img/pc/service_img.jpg" class="img-fluid rounded" alt="">
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
    export default {
        name: 'pricing',
        data (){
            return {
                cur_lan:localStorage.getItem('cur_lan') || 'jp',
                lan:JSON.parse(localStorage.getItem('creis_web_language_data')).data,
                pricingTable: [

                    {
                        thumb: require('../assets/img/pricing/aeroland-branding-pricing-image-02.png'),
                        title: '1セクター',
                        value: '75万円',
                        duration: '月',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: true,
                        price: ['　​', '', '', '']
                    },
                    {
                        thumb: require('../assets/img/pricing/aeroland-branding-pricing-image-03.png'),
                        title: '2セクター',
                        value: '150万',
                        duration: '月',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: true,
                        price: ['ああああああああ', 'ああああああああ', 'ああああああああ', 'ああああああああ']
                    },
                    {
                        thumb: require('../assets/img/pricing/aeroland-branding-pricing-image-04.png'),
                        title: 'Enterprise',
                        value: '300万',
                        duration: '月',
                        alt: 'Pricing Thumb',
                        isPopular: false,
                        active: true,
                        price: ['ああああああああ', 'ああああああああ', 'ああああああああ', 'ああああああああ']
                    }
                ]
            }
        }
    }
</script>